import { trackEvent } from 'dibs-tracking';

type TrackingLabel = 'invoice' | 'checkout' | 'account';

export const trackNoTaxDocsViewed = (label: TrackingLabel): void => {
    trackEvent({
        action: 'no tax docs - viewed',
        category: 'trade features',
        label,
    });
};

export const trackHasTaxDocsViewed = (label: TrackingLabel): void => {
    trackEvent({
        action: 'has tax docs - viewed',
        category: 'trade features',
        label,
    });
};

export const trackHasTaxDocsForOtherStateViewed = (label: TrackingLabel): void => {
    trackEvent({
        action: 'doc for other state - viewed',
        category: 'trade features',
        label,
    });
};

export const trackNoTaxDocsViewedTooltip = (label: TrackingLabel): void => {
    trackEvent({
        action: 'no tax docs - viewed tool tip',
        category: 'trade features',
        label,
    });
};

export const trackHasTaxDocsViewedTooltip = (label: TrackingLabel): void => {
    trackEvent({
        action: 'has tax docs - viewed tool tip',
        category: 'trade features',
        label,
    });
};

export const trackHasTaxDocsForOtherStateViewedTooltip = (label: TrackingLabel): void => {
    trackEvent({
        action: 'doc for other state - viewed tool tip',
        category: 'trade features',
        label,
    });
};

export const trackRemoveTaxClick = (label: TrackingLabel): void => {
    trackEvent({
        action: 'has tax docs - clicked to remove tax',
        category: 'trade features',
        label,
    });
};

export const trackNoTaxDocsClick = (label: TrackingLabel): void => {
    trackEvent({
        action: 'no tax docs - clicked CTA',
        category: 'trade features',
        label,
    });
};

export const trackHasTaxDocsForOtherStateClick = (label: TrackingLabel): void => {
    trackEvent({
        action: 'doc for other state - clicked CTA',
        category: 'trade features',
        label,
    });
};

export const trackHasTaxDocsClickedUpdate = (): void => {
    trackEvent({
        action: 'has tax docs - clicked Update',
        category: 'trade features',
        label: 'account',
    });
};
